import React, { Component } from 'react'

import { CrfContext } from '../../CrfContext'

import SideNav from '../sidenav/Sidenav'
import { Link } from 'react-router-dom'

import './CheckAvailable.css'

import axios from 'axios'
import { DownloadCheckAvailable } from '../downloadAsCSV/downloadAsCsv'
import CustomeText from './customText.js'
import CustomText from '../myrequest/customText'
export class CheckAvailable extends Component {
  state = {
    approvedRequest: false,
    allRequests: [],
    grandTotal: '0.00'
  }

  componentDidMount () {
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        let totalNetPrice = 0
        for (const obj of response.data.data.filter(
          crf => crf.status === 'Check Available'
        )) {
          totalNetPrice =
            parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice)
        }
        this.setState({
          allRequests: response.data.data
            .filter(crf => crf.status === 'Check Available')
            .reverse(),
          grandTotal: totalNetPrice.toFixed(2)
        })
        //   console.log(this.state.myRequests)
      })
      .catch(error => {
        console.log(error.response)
      })
  }

  formatDate = date => {
    let dateArray = ''
    let month = ''
    let day = ''
    let year = ''

    if (date.length === 10) {
      dateArray = date.split('/')
      month = dateArray[0]
      day = dateArray[1]
      year = dateArray[2]
    } else {
      dateArray = date.split('-')
      month = dateArray[1]
      day = dateArray[2].substring(0, 2)
      year = dateArray[0]
    }
    switch (dateArray[1]) {
      case '02':
        month = 'Feb'
        break
      case '03':
        month = 'Mar'
        break
      case '04':
        month = 'Apr'
        break
      case '05':
        month = 'May'
        break
      case '06':
        month = 'Jun'
        break
      case '07':
        month = 'Jul'
        break
      case '08':
        month = 'Aug'
        break
      case '09':
        month = 'Sep'
        break
      case '10':
        month = 'Oct'
        break
      case '11':
        month = 'Nov'
        break
      case '12':
        month = 'Dec'
        break
      default:
        month = 'Jan'
    }
    return `${month} ${day}, ${year}`
  }

  addCommas (nStr) {
    nStr += ''
    var x = nStr.split('.')
    var x1 = x[0]
    var x2 = x.length > 1 ? '.' + x[1] : ''
    var rgx = /(\d+)(\d{3})/
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }
    return x1 + x2
  }
  render () {
    const allRequests = this.state.allRequests

    return (
      <CrfContext.Consumer>
        {context => (
          <div id='mainPage'>
            <div id='sidePanel'>
              <SideNav
                testState={context.state.testState}
                toggleBtn1List={context.toggleBtn1List}
                toggleBtn2List={context.toggleBtn2List}
                btn1List={context.state.btn1List}
                btn2List={context.state.btn2List}
                userRole={context.state.userRole}
              />
            </div>
            <div id='mainPanel' style={{ paddingRight: '5px' }}>
              <br />
              <div>
                <h1>Check Available</h1>
              </div>
              <div style={{ float: 'right' }}>
                {this.state.allRequests.length > 0 ? (
                  <button
                    onClick={() => {
                      DownloadCheckAvailable(this.state.allRequests)
                    }}
                    id='ph2Btn'
                    className='ph2Btn'
                  >
                    Download as CSV
                  </button>
                ) : null}
              </div>
              <br />
              {/* TABLE DATA */}
              <div className='myRequestTableHeader' style={{ width: '100%' }}>
                <div className='tHead'>CRF#</div>
                <div className='tHead'>Date Created</div>
                <div className='tHead'>Due date</div>
                <div className='tHead'>Vendor</div>
                <div className='tHead'>Check Amount</div>
                <div className='tHead'>Check date</div>
                <div className='tHead'>Check number</div>
                <div className='tHead' style={{ padding: '0px' }}>
                  Check available date
                </div>
                <div className='tHead'>Department</div>
                <div className='tHead'>Requestor</div>
              </div>
              <br />
              {allRequests.map(requestsArray => (
                <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
                  <div
                    className='tableData'
                    style={{
                      width: '100%',
                      marginLeft: '0px',
                      height: '60px'
                    }}
                  >
                    <div className='tData'>
                      <h4>{requestsArray.crfNo}</h4>
                    </div>
                    <div className='tData'>
                      <h4>{requestsArray.creationDate.slice(4, 16)}</h4>
                    </div>
                    <div className='tData'>
                      <h4>{this.formatDate(requestsArray.dueDate)}</h4>
                    </div>
                    <div className='tData'>
                      <CustomText>{requestsArray.vendor.bpName}</CustomText>
                    </div>
                    <div className='tData'>
                      <h4>
                        <span>&#8369;</span>
                        {requestsArray.totalNetPrice
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                      </h4>
                    </div>
                    <div className='tData'>
                      <h4>{this.formatDate(requestsArray.checkDate)}</h4>
                    </div>
                    <div className='tData'>
                      <h4>{requestsArray.checkNo}</h4>
                    </div>
                    <div className='tData'>
                      <h4>
                        {this.formatDate(requestsArray.checkAvailableDate)}
                      </h4>
                    </div>
                    <div className='tData'>
                      <CustomText>
                        {requestsArray.department.centerName}
                      </CustomText>
                    </div>
                    <div className='tData'>
                      <h4>{`${requestsArray.requestor.firstName} ${requestsArray.requestor.lastName}`}</h4>
                    </div>
                  </div>
                </Link>
              ))}
              <br />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  paddingRight: '3rem'
                }}
              >
                <div style={{ flexBasis: '20%' }}>
                  <p style={{ textAlign: 'right' }}>Total Amount:</p>
                </div>
                <div style={{ flexBasis: '30%' }}>
                  <p style={{ textAlign: 'right' }}>
                    &#8369; {this.addCommas(this.state.grandTotal)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    )
  }
}

const link = {
  textDecoration: 'none',
  color: 'black'
}

export default CheckAvailable
